import React from "react";

import "./titleView.scss";

export const TitleView = ({
  title,
  CustomTitleViewMain,
  CustomTextTitle,
  testId
}: any) => {
  return (
    <div data-testid={testId} className={`titleViewMain ${CustomTitleViewMain}`}>
      <p className={`textTitle ${CustomTextTitle}`}>{title}</p>
    </div>
  );
};
